import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} className={className} viewBox='0 0 50 43' fill={fillColor}>
      <g>
        <rect fill='none' height='45' width='52' y='-1' x='-1' />
      </g>
      <g>
        <rect x='-1.873767' y='-4.339251' width='50' height='50' fill='none' />
        <path
          strokeMiterlimit='10'
          strokeLinejoin='round'
          strokeLinecap='round'
          stroke={fillColor}
          fill='none'
          d='m45.202297,40.179534c2.552,-3.815 4.041,-8.4 4.041,-13.338c0,-13.264 -10.736,-24 -24,-24s-24,10.736 -24,24c0,4.936 1.488,9.521 4.037,13.332'
        />
        <path
          stroke={fillColor}
          strokeMiterlimit='10'
          strokeLinejoin='round'
          strokeLinecap='round'
          fill='none'
          d='m40.411856,37.854309c1.975636,-3.14407 3.12835,-6.92273 3.12835,-10.99231c0,-10.93132 -8.311283,-19.77924 -18.579617,-19.77924s-18.579607,8.84792 -18.579607,19.77924c0,4.06793 1.151938,7.84659 3.125244,10.98737'
        />
        <line
          strokeLinecap='round'
          strokeLinejoin='round'
          y2='32.642997'
          x2='16.844181'
          y1='37.771202'
          x1='9.644969'
          fillOpacity='null'
          strokeOpacity='null'
          stroke={fillColor}
          fill='none'
        />
        <line
          transform='rotate(61.528564453125 36.42012023925781,35.89743423461914) '
          strokeLinecap='round'
          strokeLinejoin='round'
          y2='33.333333'
          x2='40.019723'
          y1='38.461538'
          x1='32.820512'
          fillOpacity='null'
          strokeOpacity='null'
          stroke={fillColor}
          fill='none'
        />
        <polygon
          stroke='null'
          transform='rotate(-33.583351135253906 29.662931442260742,19.676103591918938)'
          points='16.938372164,20.548442840 41.9884572,11.586392402 42.3874936,12.163652420 21.318811923,27.76581382'
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
